import React, { useState, useEffect, useContext } from "react"
import { useHistory } from "react-router-dom"

import Package from "../../../../../package.json"

import RegistradorContext from "../../../../contexts/registradorContext"
import ServicosContext from "../../../../contexts/servicosContext"
import { useSnackbar } from "notistack"

import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import CheckIcon from "@material-ui/icons/Check"
import Backdrop from "@material-ui/core/Backdrop"
import Radio from "@material-ui/core/Radio"
import AlertFixo from "@material-ui/lab/Alert"
import PhoneIcon from "@material-ui/icons/Phone"
import EditIcon from "@material-ui/icons/Edit"
import RadioGroup from "@material-ui/core/RadioGroup"
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber"
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import NativeSelect from "@material-ui/core/NativeSelect"
import PrintIcon from "@material-ui/icons/Print"
import TransferWithinAStationIcon from "@material-ui/icons/TransferWithinAStation"
import PaymentIcon from "@material-ui/icons/Payment"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import CardActions from "@material-ui/core/CardActions"
import SwapHorizIcon from "@material-ui/icons/SwapHoriz"
import InputAdornment from "@material-ui/core/InputAdornment"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import ButtonGroup from "@material-ui/core/ButtonGroup"
import InputBase from "@material-ui/core/InputBase"
import AddIcon from "@material-ui/icons/Add"
import RemoveIcon from "@material-ui/icons/Remove"
import FormLabel from "@material-ui/core/FormLabel"
import FormGroup from "@material-ui/core/FormGroup"
import Skeleton from "@material-ui/lab/Skeleton"
import FormControl from "@material-ui/core/FormControl"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import ArrowRightIcon from "@material-ui/icons/ArrowRight"
import CircularProgress from "@material-ui/core/CircularProgress"
import Button from "@material-ui/core/Button"
import ListSubheader from "@material-ui/core/ListSubheader"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import PropTypes from "prop-types"
import Box from "@material-ui/core/Box"
import PersonPinIcon from "@material-ui/icons/PersonPin"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import { Card, Row, Col } from "react-bootstrap"
import Avatar from "@material-ui/core/Avatar"
import TextField from "@material-ui/core/TextField"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import Divider from "@material-ui/core/Divider"
import ListItemText from "@material-ui/core/ListItemText"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import Fab from "@material-ui/core/Fab"
import Slide from "@material-ui/core/Slide"
import InputLabel from "@material-ui/core/InputLabel"
import clsx from "clsx"
import Drawer from "@material-ui/core/Drawer"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import * as Sentry from "@sentry/react"

import TelefoneMask from "../../../../masks/telefone"

import { listarClientes, RegistrarLogErro } from "../../../../services/clientefiel"

import { BuscarMesas } from "../../../../services/integracao"

import { carrinhoNovo, valorTotalDaMesa } from "../../functions"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => ({
    fixed: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedMesa: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 2000,
    },
    fixedMesaFechar: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        zIndex: 2000,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        // zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    appBar: {
        position: "fixed",
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
        // height: "100%",
        // minHeight: "-webkit-fill-available",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
}))

export default function Index() {
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const classes = useStyles()
    const theme = useTheme()
    const history = useHistory()

    const {
        listaRepeticao,
        listaMesas,
        openGerenciarMesa,
        setOpenGerenciarMesa,
        setPedidosDaMesa,
        setOpenGerenciarPedidosMesa,
    } = useContext(RegistradorContext)

    const lista = listaMesas.filter(e => !e.naoTem)

    console.log("listaMesas", lista)
    const { enqueueSnackbar } = useSnackbar()

    const { configuracoes } = useContext(ServicosContext)

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const handleCloseGerenciamentoMesa = () => {
        try {
            document.getElementById("procurar-cliente").value = ""
            setOpenGerenciarMesa(false)
        } catch (error) {
            RegistrarLogErro(error, "handleCloseGerenciamentoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    return openGerenciarMesa ? (
        <Dialog
            fullScreen
            open={openGerenciarMesa}
            onClose={handleCloseGerenciamentoMesa}
            TransitionComponent={Transition}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseGerenciamentoMesa}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        ({lista.length}) Mesas Abertas
                    </Typography>
                </Toolbar>
            </AppBar>
            <Container className={classes.appContainer}>
                <Row>
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        style={{ marginBottom: "0.5em", textAlign: "center" }}
                    >
                        <Button
                            size="small"
                            onClick={() => {
                                setOpenGerenciarMesa(false)
                            }}
                            style={{ color: "#28a745" }}
                        >
                            Voltar
                        </Button>
                    </Col>

                    {listaMesas.length
                        ? listaMesas.map((mesa, index) => (
                              <React.Fragment key={index}>
                                  {mesa?.pedidosMesa?.length ? (
                                      <Col xs={12} md={6} lg={4} style={{ marginBottom: "0.5em" }}>
                                          <Card className={classes.root} style={{ height: "100%" }}>
                                              <CardActionArea
                                                  onClick={() => {
                                                      setPedidosDaMesa(mesa)
                                                      setOpenGerenciarPedidosMesa(true)
                                                  }}
                                                  style={{
                                                      height: "100%",
                                                      flexFlow: "column-reverse",
                                                      alignItems: "normal",
                                                  }}
                                              >
                                                  <Row
                                                      style={{
                                                          margin: 0,
                                                          textAlign: "",
                                                          width: "100%",
                                                          padding: "1em",
                                                          alignItems: "center",
                                                      }}
                                                  >
                                                      <Col
                                                          xs={4}
                                                          md={3}
                                                          lg={3}
                                                          style={{
                                                              padding: 0,
                                                              textAlign: "center",
                                                              fontSize: "5em",
                                                          }}
                                                      >
                                                          {mesa.numeroMesa}
                                                      </Col>
                                                      <Col xs={8} md={9} lg={9}>
                                                          <Typography
                                                              variant="body2"
                                                              color="textSecondary"
                                                              component="p"
                                                          >
                                                              {mesa.pedidosMesa?.length} pedidos
                                                          </Typography>

                                                          <Typography gutterBottom component="h2">
                                                              {
                                                                  mesa.pedidosMesa[
                                                                      mesa.pedidosMesa.length - 1
                                                                  ].nomePedido
                                                              }
                                                          </Typography>

                                                          <Typography
                                                              className={"StatusEstabelecimento"}
                                                              variant="body2"
                                                              component="p"
                                                          >
                                                              {Intl.NumberFormat("pt-BR", {
                                                                  style: "currency",
                                                                  currency: "BRL",
                                                              }).format(
                                                                  valorTotalDaMesa(mesa.pedidosMesa)
                                                              )}
                                                          </Typography>
                                                      </Col>
                                                  </Row>
                                              </CardActionArea>
                                              <CardActions
                                                  style={{ cursor: "pointer", padding: "0" }}
                                              >
                                                  <Typography
                                                      variant={"button"}
                                                      style={{
                                                          textAlign: "center",
                                                          padding: "3px",
                                                      }}
                                                      className={
                                                          configuracoes.user.parametros == null
                                                              ? "botaoCinza naoArredondado"
                                                              : configuracoes.user.parametros
                                                                    .exibirRegistroPedidos
                                                              ? "botaoVerde naoArredondado"
                                                              : "botaoVermelho naoArredondado"
                                                      }
                                                  >
                                                      ABERTA
                                                  </Typography>
                                              </CardActions>
                                          </Card>
                                      </Col>
                                  ) : null}
                              </React.Fragment>
                          ))
                        : listaRepeticao.map((repeticao, index) => (
                              <Col
                                  key={index}
                                  xs={12}
                                  md={6}
                                  lg={4}
                                  style={{ marginBottom: "0.5em" }}
                              >
                                  <Skeleton
                                      variant="rect"
                                      width={"100%"}
                                      height={145}
                                      style={{ marginBottom: "1em" }}
                                  />
                              </Col>
                          ))}
                </Row>
            </Container>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
